<template>
	<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<g>
			<path d="m4.93907,3.01757l9.09374,0.16592l4.96876,5.52158l-0.12667,12.16591l-13.87164,-0.0625l-0.06418,-17.79091z" fill="white" />
			<path
				fill="#000"
				fill-opacity="0.87"
				d="m6,2a2,2 0 0 0 -2,2l0,16a2,2 0 0 0 2,2l12,0a2,2 0 0 0 2,-2l0,-12l-6,-6l-8,0m0,2l7,0l0,5l5,0l0,11l-12,0l0,-16m2,8l0,2l8,0l0,-2l-8,0m0,4l0,2l5,0l0,-2l-5,0z"
			/>
		</g>
	</svg>
</template>
